import day from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

import { deserializeParams } from '@webapp/common/lib/params';
import { undefDestroy } from '@webapp/common/lib/utils';
import { LicenseType } from '@webapp/common/resources/entities/license';

import type { Folder } from './folder';
import { initialFolder } from './folder';
import type { IndividualPassword, IndividualPasswordResponse, Survey } from './survey';
import { initialSurvey, SurveyStatus } from './survey';

export const mapFolder = ({ ID, NAME, ORDERING, PARENT, SURVEY_COUNT, USER_NAME, CREATOR_ID }: any): Folder => ({
    ...cloneDeep(initialFolder),
    id: ID,
    name: NAME,
    userName: USER_NAME,
    count: SURVEY_COUNT,
    order: ORDERING,
    parent: PARENT,
    visibleCount: 0,
    children: [],
    creatorId: CREATOR_ID,
});

export const mapSurvey = (r: any, upsert = false): Survey => {
    const survey: Survey = {
        ...(upsert ? cloneDeep(initialSurvey) : undefined),
        limits: r.LIMIT_EXCEEDED,
        lowLimit: r.LOW_LIMIT,
        folderId: r.FOLDER_ID,
        id: r.ID,
        name: r.NAME,
        title: r.TITLE,
        userName: r.USER_NAME,
        creatorName: r.CREATOR_NAME,
        creatorEmail: r.CREATOR_EMAIL,
        status: r.STATUS,
        enabled: r.STATUS === SurveyStatus.INWORK,
        startDatetime: r.START_DATE === null ? '' : day(r.START_DATE),
        // endDatetime: r.STOP_DATE === null ? r.$maxEndDate : r.STOP_DATE,
        endDatetime: r.STOP_DATE === null ? '' : day(r.STOP_DATE),
        createdDatetime: r.CREATE_DATE,
        proExpDatetime: r.$maxEndDate,
        subdomain: r.$REWRITE,
        totalFileSize: r.$TOTAL_SIZE,
        totalFileCount: r.$TOTAL_COUNT,
        totalAudioSize: r.$AUDIO_SIZE,
        totalAudioCount: r.$AUDIO_COUNT,
        password: !r.PASSWORD ? initialSurvey.password : r.PASSWORD,
        isPro: !!r.USER_LICENSE_ID && r.USER_LICENSE_ID !== LicenseType.ONETIME,
        order: r.ORDERING,
        responseCount: r.$QUERY_COUNT,
        timeCount: Number(r.$TIME_TOTAL),
        questionTypes: new Set(r.$QuestionTypes || []),
        hideFooter: Boolean(r.$addons && r.$addons.hideFooter),
        defaultLang: r.DEFAULT_LANG,
        multiLang: r.MULTI_LANG,
    };

    if (r.$params && !upsert) {
        try {
            survey['addons'] = deserializeParams(r.$params);
        } catch (e) {
            console.error(e);
        }
    }

    return survey;
};
export const reverseMapSurvey = (s: Survey): any =>
    undefDestroy({
        title: s.title,
        name: s.name,
        userName: s.userName,
        status: s.status,
        password: s.password,
        start_date: s.startDatetime,
        stop_date: s.endDatetime,
        rewrite: s.subdomain,
    });

export const mapPasswords = (passwords: Array<IndividualPasswordResponse>): Array<IndividualPassword> =>
    passwords.map(({ ID, PASSWORD, USED }) => ({
        id: ID,
        value: PASSWORD,
        used: USED,
    }));
